// extracted by mini-css-extract-plugin
module.exports = {"logoBox":"style_logoBox__1fPQt","logoIcon":"style_logoIcon__2k3Ph"};